import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Authentication/Login";
import Home from "./pages/Home/Home";
import Citizens from "./pages/Citizens/Citizens.jsx";
import PrivateRoute from "./Routes/PrivateRoute";
import RedirectToHomeIfAuthenticated from "./Routes/RedirectToHomeIfAuthenticated";
import TrackLocation from "./Routes/TrackLocation";
import RedirectToPrevious from "./Routes/RedirectToPrevious";
import Profile from "./pages/Profile/Profile.jsx";
import Documentation from "./pages/Documentation/Documentation.jsx";
import Notifications from "./pages/Notifications/Notifications.jsx";
import ResearchDocuments from "./pages/ResearchDocuments/ResearchDocuments.jsx";
import Export from "./pages/Export/Export.jsx";
import { NotificationProvider } from "./components/Notifications/NotificationContext.jsx";

function App() {
  return (
    <div className="App">
      <NotificationProvider>
        <BrowserRouter>
          <TrackLocation>
            <Routes>
              <Route
                path="/"
                element={
                  <RedirectToHomeIfAuthenticated>
                    <Login />
                  </RedirectToHomeIfAuthenticated>
                }
              />
              <Route
                path="/home"
                element={
                  <PrivateRoute>
                    <Home />
                  </PrivateRoute>
                }
              />
              <Route
                path="/citizens"
                element={
                  <PrivateRoute>
                    <Citizens />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />
              <Route
                path="/documentation"
                element={
                  <PrivateRoute>
                    <Documentation />
                  </PrivateRoute>
                }
              />
              <Route
                path="/notifications"
                element={
                  <PrivateRoute>
                    <Notifications />
                  </PrivateRoute>
                }
              />
              <Route
                path="/research-documents"
                element={
                  <PrivateRoute>
                    <ResearchDocuments />
                  </PrivateRoute>
                }
              />
              <Route
                path="/export"
                element={
                  <PrivateRoute>
                    <Export />
                  </PrivateRoute>
                }
              />

              <Route path="*" element={<RedirectToPrevious />} />
            </Routes>
          </TrackLocation>
        </BrowserRouter>
      </NotificationProvider>
    </div>
  );
}

export default App;
